import React, { Fragment } from 'react';
import { UNIT_BRANCH, UNIT_GROUP, UNIT_WARD } from 'src/utils/appConstants/appConstants';
import { WardDescriptor, StakeDescriptor } from './UnitBadge.style';
import { useTranslation } from 'react-i18next';

export const UnitBadge = ({ unitType }: { unitType }) => {
  const { t } = useTranslation('labels');
  const unitTypeUpper = unitType?.toString().toUpperCase() ?? '';
  return unitTypeUpper
    ? (
      [UNIT_WARD, UNIT_BRANCH, UNIT_GROUP].includes(unitTypeUpper)
        ? (
          <WardDescriptor className="unit-badge"> {t(`${unitTypeUpper}`)} </WardDescriptor>
        )
        : (
          <StakeDescriptor className="unit-badge"> {t(`${unitTypeUpper}`)} </StakeDescriptor>
        )
    )
    : <Fragment />;
};

export default UnitBadge;
